import React, { useRef, useLayoutEffect } from "react";

// TODO: Object props
export default (Component, { events }) =>
  (props) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
      const { current } = ref;
      Object.entries(events).forEach(([eventName, cbName]) => {
        const cbFunc = props[cbName];
        if (typeof cbFunc === "function") {
          current.addEventListener(eventName, cbFunc);
        }
      });

      return () => {
        Object.entries(events).forEach(([eventName, cbName]) => {
          const cbFunc = props[cbName];
          if (typeof cbFunc === "function") {
            current.removeEventListener(eventName, cbFunc);
          }
        });
      };
    }, [props]);

    return <Component ref={ref} {...props} />;
  };
